import { AxiosError } from "axios";
import { UseQueryOptions, useQuery } from "react-query";
import { IClient, Route } from "@edgetier/watchtower-types";
import { axios } from "utilities/axios";

/**
 * Request the clients from the backend.
 * @returns An array of clients.
 */
export const getClients = async (url: string, parameters: Object) => {
    const { data } = await axios.get<{ items: IClient[] }>(url, { params: parameters });
    return data.items;
};

/**
 * A query to get all the clients for a user.
 * @returns React Query result.
 */
const useUsersClients = <T = IClient[]>(
    parameters: Object = {},
    configuration: UseQueryOptions<IClient[], AxiosError<void>, T> = {}
) => {
    const url = Route.UsersClients;
    return useQuery<IClient[], AxiosError<void>, T>([url, parameters], () => getClients(url, parameters), {
        cacheTime: Infinity,
        staleTime: Infinity,
        ...configuration,
    });
};

export default useUsersClients;
